import { act } from "react";
import { activeComponent } from "../App";


export const listen = (controller = "", state = "global", actions = [], wheel = false, excludes = [], overides = [], passthrough = [], onBarcodeScan = null) => {

    let barcodeBuffer = '';  // Buffer to store barcode input
    let barcodeTimeout;  // Timeout to clear buffer after a delay
    let barcodeActive = false;  // Flag to track barcode input state
    const barcodeStartChar = '~';  // Barcode starts with a tilde
    const barcodeDelay = 300;  // Delay in ms for collecting the rest of the barcode

  


    // Excludes for letting through keyboard events while on an input/text

    if (actions.length === 0) {
        // don't event try...
        return;
    }

    const handleKeyDown = (e) => {

        // Ensure state matches... e
        if (window.bm_state.value !== state && state !== "global.global") {
            return;
        }

        if (e.key === "ArrowDown" || e.key === "ArrowUp") {

         
            e.preventDefault();
        }



        if (e.key === barcodeStartChar || barcodeBuffer.startsWith(barcodeStartChar)) {
            if (e.key === "Enter") {
                // Stop and trim off the "Enter"
                const barcode = barcodeBuffer.slice(1);  // Remove the start char (e.g., tilde)
                if (barcode.length > 0 && onBarcodeScan) {
                    onBarcodeScan(barcode);  // Call barcode scan handler
                }
                barcodeBuffer = '';  // Reset buffer
            } else {
                barcodeBuffer += e.key;
                clearTimeout(barcodeTimeout);
                barcodeTimeout = setTimeout(() => {
                    if (barcodeBuffer.length > 1 && barcodeBuffer.startsWith(barcodeStartChar)) {
                        const barcode = barcodeBuffer.slice(1);  // Remove the tilde for the actual barcode
                        if (onBarcodeScan) {
                            onBarcodeScan(barcode);  // Call barcode scan handler
                        }
                    }
                    barcodeBuffer = '';  // Reset buffer
                }, barcodeDelay);
            }

            return;
        }


        // Check for "any" key
        const _find_any = actions.find(item => item?.key?.key === "any")
        if (_find_any) {
            _find_any.action(e);
            return;
        }

        // Check for overides...
        if (state === "global.global") {
            let _blocked = false;
            window.k.listeners.get("keydown").forEach((item) => {
                item.overides.forEach(overide => {
                    if (overide.key === e.key) {

                        _blocked = true;
                    }
                })
            })

            if (_blocked) {

                return;
            }
        }




        if (e.target?.tagName === 'INPUT' || e.target?.tagName === 'TEXTAREA' || e.target?.isContentEditable) {





            const match = excludes.find(item => {
                if (item.key !== e.key) return false;
                if (item.shiftKey && !e.shiftKey) return false;
                if (item.altKey && !e.altKey) return false;
                if (item.ctrlKey && !e.ctrlKey) return false;
                return true;
            });

            const allowed_globals = ["F2"];

            if (match || allowed_globals.includes(e.key)) {
                // let it pass...
            } else {
                return;
            }


        }


        actions.forEach(element => {



            // ensure has key and action...
            if (!element.hasOwnProperty("key") || !element.hasOwnProperty("action")) {
                return;
            }

            // check to see if augment keys are used...
            if (e?.shiftKey || element?.key?.shiftKey) {
                if (e.shiftKey !== element?.key?.shiftKey) {
                    return;
                }
            }

            // check to see if augment keys are used...
            if (e?.altKey || element?.key?.altKey) {
                if (e.altKey !== element?.key?.altKey) {
                    return;
                }
            }
            // check if there is an action on the event
            if (e?.ctrlKey || element?.key?.ctrlKey) {
                if (e.ctrlKey !== element?.key?.ctrlKey) {
                    return;
                }
            }

            // check for caps lock and switch to lowercase
            const isCaps = e.getModifierState("CapsLock");
            const key = isCaps && e.key.length === 1 ? e.key.toLowerCase() : e.key;


            if (key === element?.key?.key) {

                // Don't prevent default, return event to 
                // the function to handle 
                // Timeout stops events that toggle routes from double firing.. 
                if (passthrough.find(item => item.key === key)) {
                    setTimeout(() => { element.action(e) }, 1);
                } else {
                    // prevent event, run function
                    e.preventDefault();


                    setTimeout(() => { element.action(e) }, 1);

                }
            }

        });

    };

    const handleWheel = (e) => {

        
        // e.preventDefault();
        if (window.bm_state.value !== state) {
            return;
        }
        if (wheel) {
            wheel(e)
        }
    };

    // Add the event listeners
    window.k.addListener('keydown', handleKeyDown, excludes, overides, state, actions, controller);
    if (wheel) {
        window.k.addListener('wheel', handleWheel, excludes, overides, state, actions, controller);
    }


    // Cleanup the event listeners
    return () => {
        window.k.removeListener('keydown', handleKeyDown);
        if (wheel) {
            window.k.removeListener('wheel', handleWheel);
        }
    };
};